import React from "react";

const ProviderCbxFilter = ({
  gameProviders,
  selectedProvider,
  setSelectedProvider,
  widthCbx,
  label,
  setChangeProviderFilter,
  disabled,
}) => {
  // This constant is used internally to set the selected provider to the filters
  const handleFilterProviderChange = (event) => {
    setSelectedProvider(parseInt(event.target.value));
    if (typeof setChangeProviderFilter === "function") {
      setChangeProviderFilter(true);
    }
  };

  return (
    <>
      {label && (
        <label className="lead" style={{ width: "80px" }}>
          Provider:
        </label>
      )}

      <select
        id="IdGameProvider"
        name="IdGameProvider"
        className="form-control"
        value={selectedProvider}
        style={{
          width: widthCbx,
          fontSize: "14px",
          display: "inline-block",
          cursor: "pointer",
        }}
        onChange={handleFilterProviderChange}
        disabled={disabled}
      >
        <option value={-1}>All Provider Filter</option>
        {gameProviders.map((provider, i) => {
          return (
            <option key={i} value={provider.IDGameProvider}>
              {provider.Description}
            </option>
          );
        })}
      </select>
    </>
  );
};

export default ProviderCbxFilter;
